import { SolutionsHero } from '@/components/solutions/SolutionsHero';
import { SolutionsCTA } from '@/components/solutions/SolutionsCTA';

const Solutions = () => {
  return (
    <>
      <SolutionsHero />
      <SolutionsCTA />
    </>
  );
};

export default Solutions;
